module.exports = __webpack_public_path__ + "static/media/SWINGBY-BNB.eef1fc4c.svg";